const PROCUREMENT_STORAGE_KEY = 'crmProcurementDraft';

export function saveProcurementDraft(lines) {
  sessionStorage.setItem(PROCUREMENT_STORAGE_KEY, JSON.stringify(lines));
}

export function loadProcurementDraft() {
  try {
    const raw = sessionStorage.getItem(PROCUREMENT_STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function clearProcurementDraft() {
  sessionStorage.removeItem(PROCUREMENT_STORAGE_KEY);
}
